<template>
  <div class="article">
    <sHeader :activeIndex="activeIndex"/>

    <div class="page-content">
      <div class="banner" v-if="banner">
        <img :src="banner">
      </div>
      <template v-for="(item, index) in videos">
        <VideoItem :data="item" :key="index" />
      </template>
    </div>

  </div>
</template>

<script>
import sHeader from '@/components/templates/sHeader'
import VideoItem from '@/components/templates/VideoItem'

export default {
  components: {
    sHeader,
    VideoItem
  },
  mounted () {
    this.cateid = this.$route.params.cateid
    this.activeIndex = this.$route.meta.activeIndex
    console.log('category id: ' + this.cateid)
    this.$ajax.get('interface.php?media=1&type=category&id=' + this.cateid)
      .then((res) => {
        this.videos = res.data.videos
        this.banner = res.data.banner
      })
  },
  methods: {
  },
  data () {
    return {
      activeIndex: '1',
      listid: '',
      dd: '',
      banner: '',
      videos: []
    }
  }

}
</script>
<style scoped>
.banner img{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleList.vue